<template>
  <div style="overflow: hidden;height:100%;">
    <el-container style="border: 1px solid #eee;overflow: hidden;height:100%;">
      <el-aside width="200px" class="left_nav_menus">
        <el-menu :default-active="activeIndex" @select="clickLeftMenu">
          <el-menu-item index="1" v-show="role != 15 && role != 16"
            ><i class="fa fa-users fa-fw fa-lg" aria-hidden="true"></i>&nbsp;
            跟进任务</el-menu-item
          >
          <!-- <el-menu-item
            index="6"
            v-show="(role === 15 || role === 16) && dccEnable"
            ><i class="fa fa-users fa-fw fa-lg" aria-hidden="true"></i>&nbsp;
            集团线索</el-menu-item
          > -->
          <el-menu-item index="2" v-show="role != 15 && role != 16"
            ><i class="fa fa-file-text-o fa-fw fa-lg" aria-hidden="true"></i
            >&nbsp; 线索处理</el-menu-item
          >
          <el-menu-item index="3" v-if="allowFailVerify"
            ><i class="fa fa-wrench fa-fw fa-lg" aria-hidden="true"></i>&nbsp;
            战败审核</el-menu-item
          >
          <el-menu-item index="4" v-if="allowOrderVerify"
            ><i class="fa fa-sticky-note-o fa-fw fa-lg" aria-hidden="true"></i
            >&nbsp; 订单审核</el-menu-item
          >
          <el-menu-item index="5" v-if="allowOrderAlloc"
            ><i class="fa fa-automobile fa-fw fa-lg" aria-hidden="true"></i
            >&nbsp; 待配车</el-menu-item
          >
        </el-menu>
      </el-aside>

      <el-container style="overflow-y:auto;overflow-x:hidden;">
        <div style="padding:20px;width:100%;">
          <router-view></router-view>
        </div>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      allowFailVerify: this.$common.getLoginInfo().allowFailVerify,
      allowOrderVerify: this.$common.getLoginInfo().allowOrderVerify,
      allowOrderAlloc: this.$common.getLoginInfo().allowOrderAlloc,
      dccEnable: this.$common.getLoginInfo().dccEnable,
      isAdmin: this.$common.getAdmin(),
      role: this.$common.getLoginInfo().role,
      activeIndex: "1",
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.path.startWith("/activity/tasks")) {
        vm.activeIndex = "1";
      }
      if (to.path.startWith("/activity/clue-clear")) {
        vm.activeIndex = "2";
      }
      if (to.path.startWith("/activity/fail-verify")) {
        vm.activeIndex = "3";
      }
      if (to.path.startWith("/activity/order-verify")) {
        vm.activeIndex = "4";
      }
      if (to.path.startWith("/activity/order-approved")) {
        vm.activeIndex = "5";
      }
      // if (to.path.startWith("/activity/bussiness-clue")) {
      //   vm.activeIndex = "6";
      // }
    });
  },
  beforeRouteUpdate (to, from, next) {
    if (to.path.startWith("/activity/tasks")) {
        this.activeIndex = "1";
      }
      if (to.path.startWith("/activity/clue-clear")) {
        this.activeIndex = "2";
      }
      if (to.path.startWith("/activity/fail-verify")) {
        this.activeIndex = "3";
      }
      if (to.path.startWith("/activity/order-verify")) {
        this.activeIndex = "4";
      }
      if (to.path.startWith("/activity/order-approved")) {
        this.activeIndex = "5";
      }
      // if (to.path.startWith("/activity/bussiness-clue")) {
      //   this.activeIndex = "6";
      // }
    next()
  },
  created() {},
  methods: {
    clickLeftMenu(index) {
      if (index == "1") {
        this.$router.push({
          path: "/activity/tasks",
        });
      }
      if (index == "2") {
        this.$router.push({
          path: "/activity/clue-clear",
        });
      }
      if (index == "3") {
        this.$router.push({
          path: "/activity/fail-verify",
        });
      }
      if (index == "4") {
        this.$router.push({
          path: "/activity/order-verify",
        });
      }
      if (index == "5") {
        this.$router.push({
          path: "/activity/order-approved",
        });
      }
      // if (index == "6") {
      //   this.$router.push({
      //     path: "/activity/bussiness-clue",
      //   });
      // }
    },
  },
};
</script>

<style></style>
